import "./Modal.scss";
import "./AddBoatModal.scss";
import { useEffect } from "react";

function AddBoatModal({
  addModalOpen,
  addForm,
  addImages,
  setAddForm,
  setAddImages,
  onClose,
  onAddBoat,
}) {
  useEffect(() => {
    if (addModalOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [addModalOpen]);

  if (!addModalOpen) return null;

  return (
    <div
      className="popup-overlay-admin"
      onClick={(e) =>
        e.target.classList.contains("popup-overlay-admin") && onClose()
      }
    >
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h1>Add New Boat</h1>
        <div className="edit-info">
          <label>
            Name
            <input
              value={addForm.name}
              onChange={(e) => setAddForm((p) => ({ ...p, name: e.target.value }))}
              placeholder="e.g. Baboshka"
            />
          </label>
          <label>
            Type
            <input
              value={addForm.type}
              onChange={(e) => setAddForm((p) => ({ ...p, type: e.target.value }))}
              placeholder="e.g. Sailing Yacht"
            />
          </label>
          <label>
            Capacity
            <input
              type="number"
              min="1"
              value={addForm.capacity}
              onChange={(e) =>
                setAddForm((p) => ({ ...p, capacity: e.target.value }))
              }
              placeholder="e.g. 8"
            />
          </label>
          <label>
            Images
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={(e) => setAddImages(Array.from(e.target.files))}
            />
            {addImages.length > 0 && (
              <span className="file-count">{addImages.length} file(s) selected</span>
            )}
          </label>
        </div>
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="save-btn" onClick={onAddBoat}>
            Add Boat
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddBoatModal;
